import { loadScript } from './utils'
import pluginConfig from 'vue-gtm/src/config'
import GtmPlugin from './GtmPlugin'

/**
 * Installation procedure
 *
 * @param Vue
 * @param initConf
 */
const install = function (Vue, initConf = {}) {
  initConf = { ...pluginConfig, ...initConf }

  pluginConfig.id = initConf.id
  pluginConfig.debug = initConf.debug
  pluginConfig.enabled = initConf.enabled

  if (initConf.vueRouter) {
    initVueRouterGuard(Vue, initConf)
  }

  Vue.prototype.$gtm = Vue.gtm = new GtmPlugin()

  if (pluginConfig.enabled) {
    if (Array.isArray(initConf.id)) {
      initConf.id.forEach((id) => {
        loadScript(id, initConf.source)
      })
    } else {
      loadScript(initConf.id, initConf.source)
    }
  }
}

/**
 * Init the router guard.
 *
 * @param Vue - The Vue instance
 * @param vueRouter - The Vue router instance to attach guard
 * @param {string[]} ignoredViews - An array of route name to ignore
 * @param trackOnNextTick - Whether or not call trackView in Vue.nextTick
 *
 * @returns {string[]} The ignored routes names formalized.
 */
const initVueRouterGuard = function (Vue, { vueRouter, ignoredViews, trackOnNextTick }) {
  if (ignoredViews) {
    ignoredViews = ignoredViews.map(view => view.toLowerCase())
  }

  vueRouter.afterEach(to => {
    if (!to.name || (ignoredViews && ignoredViews.indexOf(to.name.toLowerCase()) !== -1)) {
      return
    }

    const name = to.meta.gtm || to.name
    const baseUrl = vueRouter.options.base || ''

    if (trackOnNextTick) {
      Vue.nextTick(() => {
        Vue.gtm.trackView(name, `${baseUrl}${to.fullPath}`)
      })
    } else {
      Vue.gtm.trackView(name, `${baseUrl}${to.fullPath}`)
    }
  })

  return ignoredViews
}

export default { install }
